<template>
  <div>
    <div class="bg" v-if="show === 1" @click="showDrop"></div>
    <div class="drop-down" @click="showDrop">
      <div class="detail-item stack" style="width: 100%;" v-if="title.length < 12">
        <input style="padding: 0" disabled="true" :value="title" placeholder="请选择位置"/>
      </div>
      <div class="detail-item" style="width: 100%;display: block" v-if="title.length >= 12">
        <el-popover
          placement="top"
          title=""
          trigger="hover"
          :content="title">
          <div class="popover" style="padding-right: 1vw;width: auto" slot="reference">
            <input style="padding: 0" disabled="true" :value="title" placeholder="请选择位置"/>
          </div>
        </el-popover>
      </div>
      <i class="icon-font" :style=[iconStyle]>&#xe61c;</i>
      <div class="drop-down-content-tree" :style=[dropStyle] :class="{'up': show === 1, 'down': show === 0}">
        <div style="padding: 0.5vw 0; width: max-content">
          <el-tree
            :load="loadNode"
            lazy
            node-key="treeId"
            ref="tree"
            highlight-current
            :expand-on-click-node="false"
            :check-strictly="true"
            @current-change="checkChange"
            :props="defaultProps">
          </el-tree>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {warehouseNode} from '../api/basic'
export default {
  name: 'TreeSingle',
  props: ['content', 'items', 'editCheckId', 'moduleType'],
  data () {
    return {
      childSiteType: '',
      canClick: true,
      title: this.content,
      show: null,
      selectId: this.editCheckId,
      up: {
        width: '0'
      },
      iconStyle: {},
      dropStyle: {},
      defaultProps: {
        children: 'children',
        label: 'name',
        isLeaf: 'leaf'
      }
    }
  },
  created: function () {
    // moduleType 01===垛位 02===垛位 03===区 00===除垛位其他任意选择 -1===任意选择
    let _this = this
    _this.selectId = this.editCheckId
    setTimeout(function () {
      _this.$refs.tree.setCheckedNodes([_this.selectId])
    }, 0)
    if (this.moduleType === '01' || this.moduleType === '02') {
      this.childSiteType = '05'
    } else if (this.moduleType === '03') {
      this.childSiteType = '04'
    } else if (this.moduleType === '00') {
      this.childSiteType = '00'
    } else if (this.moduleType === '-1') {
      this.childSiteType = '-1'
    }
  },
  watch: {
    content: function () {
      this.title = this.content
    }
  },
  methods: {
    loadNode (node, resolve) {
      if (node.level === 0) {
        this.requestTree(resolve)
      }
      // 其余节点处理
      if (node.level >= 1) {
        // resolve传到你自己的异步中去
        this.getIndex(node, resolve, node.level)
      }
    },
    // 异步加载叶子节点数据函数
    getIndex (node, resolve, level) {
      if (node.data.childSiteType === null) {
        resolve([])
      } else {
        let body = {
          warehouseNodeId: node.data.id,
          warehouseNodeType: node.data.childSiteType
        }
        warehouseNode(body).then(res => {
          console.log(res)
          console.log(node)
          res.data.map(data => {
            if (node.label === '顶级') {
              data.gatherSite = data.name
            } else {
              data.gatherSite = node.data.gatherSite + data.name
              data.warehouseBuildTime = node.data.warehouseBuildTime
            }
          })
          console.log(res.data)
          if (this.childSiteType === '00') {
            if (node.data.childSiteType === '04') {
              res.data.map(item => {
                item.leaf = true
              })
              resolve(res.data)
            } else {
              resolve(res.data)
            }
          } else if (this.childSiteType === '-1') {
            if (node.data.childSiteType === '05') {
              res.data.map(item => {
                item.leaf = true
              })
              resolve(res.data)
            } else {
              resolve(res.data)
            }
          } else {
            if (node.data.childSiteType === this.childSiteType) {
              res.data.map(item => {
                item.leaf = true
              })
              resolve(res.data)
            } else {
              resolve(res.data)
            }
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    requestTree (resolve) {
      let data = {
        childSiteType: '01',
        id: 1,
        name: '顶级',
        siteType: '00',
        treeId: '001'
      }
      resolve([data])
    },
    checkChange: function (data) {
      if (data.gatherSite !== undefined) {
        if (this.childSiteType === '00' || this.childSiteType === '-1') {
          if (data.treeId === this.selectId) {
            this.selectId = data.treeId
            this.$refs.tree.setCheckedNodes([data.treeId])
          } else {
            this.selectId = data.treeId
            this.title = data.name
            this.$refs.tree.setCheckedNodes([data.treeId])
          }
          this.$emit('sendInfo', data)
          this.showDrop()
        } else {
          if (data.siteType === this.childSiteType) {
            if (data.treeId === this.selectId) {
              this.selectId = data.treeId
              this.$refs.tree.setCheckedNodes([data.treeId])
            } else {
              this.selectId = data.treeId
              this.title = data.name
              this.$refs.tree.setCheckedNodes([data.treeId])
            }
            this.$emit('sendInfo', data)
            this.showDrop()
          }
        }
      }
    },
    showDrop: function () {
      if (this.canClick) {
        if (this.show === null) {
          this.show = 1
        } else {
          this.show = this.show === 0 ? 1 : 0
        }
        this.iconStyle.transform = this.show === 1 ? 'rotate(90deg)' : 'rotate(0)'
        if (this.show === 1) {
          this.dropStyle = {borderBottom: 'solid 0.05vw #3b79a1'}
        } else {
          this.canClick = false
          let _this = this
          setTimeout(function () {
            _this.dropStyle = {borderBottom: 'none'}
            _this.canClick = true
          }, 500)
        }
      }
    }
  },
  destroyed () {
    this.show = null
  }
}
</script>

<style scoped lang="less">
  .drop-down{
    text-align: left;
    width: 13vw;
    height: 2.43vw;
    padding: 0.63vw;
    font-size: 0.83vw;
    color: #00d2ff;
    border: solid 0.05vw #3b79a1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    z-index: 999;
  }
  .bg{
    position: fixed;
    width: 100vw;
    height: 100vh;
    background-color: transparent;
    top: 0;
    left: 0;
    z-index: 998;
  }
  .drop-down:hover{
    border: solid 0.05vw #00d2ff;
    box-shadow: 0 0 0.2vw #1fb5ac;
    cursor: pointer;
  }
  .icon-font{
    color: #3b79a1;
    position: absolute;
    right: 0.63vw;
    top: 0.68vw;
    margin-right: 0 !important;
    margin-top: 0 !important;
    transition: all .3s ease-in;
  }
  .drop-down:hover > i{
    color: #00d2ff;
  }
  .drop-down-content-tree{
    position: absolute;
    width: 13vw;
    height: 0;
    overflow:auto;
    left: -0.05vw;
    top: 2.38vw;
    background-color: rgb(40, 47, 120);
    border: solid 0.05vw #3b79a1;
    border-top: none;
    border-bottom: none;
    z-index: 8;
  }
  .drop-down-list{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
  }
  .drop-down-list-item{
    width: 100%;
    padding: 0.9vw 0.63vw;
  }
  .drop-down-list-item:hover{
    background: #474e7f;
  }
  .up{
    animation:upSile .5s forwards;
    -moz-animation:upSile .5s forwards; /* Firefox */
    -webkit-animation:upSile .5s forwards; /* Safari and Chrome */
    -o-animation:upSile .5s forwards; /* Opera */
  }
  .down{
    animation:downSile .5s forwards;
    -moz-animation:downSile .5s forwards; /* Firefox */
    -webkit-animation:downSile .5s forwards; /* Safari and Chrome */
    -o-animation:downSile .5s forwards; /* Opera */
  }
  @keyframes upSile {
    from{
      height: 0;
    }
    to{
      height: 9vw;
    }
  }
  @keyframes downSile {
    from{
      height: 300%;
    }
    to{
      height: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/LoadingTreeStack.vue